<div class="line-chart">
  @if (hasData()) {
    <highcharts-chart
      class="highcharts-light"
      [options]="chartOptions()"
    />
  } @else {
    <div class="empty">No data available.</div>
  }
</div>
